export default ($el) => {
    if ($el.$parent) {
        return $el.$parent;
    }

    return $el.$parent = $el.parentNode.closest('[x-data]')?.__x ?? null;
};